import { getValidatableOpgavekompleksetInputs } from './tasks/util.get-validatable-inputs.js';

function makeInitialOpgavekompleksetTaskEntry(data, taskId) {
  const taskData = data.tasks.find(it => it.id === taskId);
  if (!taskData) {
    throw new Error("makeInitialTaskEntry(): Unable to resolve related task");
  }
  const validatableInputs = getValidatableOpgavekompleksetInputs(data, taskId, undefined);
  return {
    id: taskId,
    state: {
      attempts: 0,
      closed: false,
      validated: false,
      opened: false,
      skipped: true
    },
    stats: {
      correct: 0,
      wrong: 0,
      total: validatableInputs.length
    },
    details: {}
  };
}

export { makeInitialOpgavekompleksetTaskEntry };
//# sourceMappingURL=util.make-initial-task-entry.js.map
